import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Top from './Top';
import { injectStyles } from './premiumStyles';
import SmartPatrolRobot from './img/智能工业巡检机器人.jpg'; // 案例与教学素材 - 智能工业巡检机器人
import Shgl5 from './img/shgl5.jpg'; // 企业践习 - 上海光联照明有限公司参观
import sz1 from './img/sz1.jpg'; // 师资建设 - 第一张图片
import courseImg from './img/qrs5.jpeg'; // 课程介绍图片
import facultyImg from './img/hz.png'; // 师资建设图片
import './index.css';
import './Home.css';

// 注入样式
injectStyles();

// 轮播图数据
const carouselData = [
    {
        id: 1,
        image: SmartPatrolRobot,
        title: "智能工业巡检机器人",
        link: "/project/8"
    },
    {
        id: 2,
        image: Shgl5,
        title: "企业实习实践",
        link: "/enterprise-project/1"
    },
    {
        id: 3,
        image: sz1,
        title: "师资建设成果",
        link: "/faculty-detail/2"
    }
];

// 案例与教学素材页面的项目数据
const projectsData = [
    {
        id: 1,
        title: "智能避障小车",
        description: "通过安装在小车四周的超声波传感器反馈车辆与障碍物的距离，小车根据各种传感器数值判断车辆所遇到的环境，控制车辆前进后退避开障碍物。该项目培养了学生在嵌入式系统设计、传感器应用和自动控制方面的综合能力。"
    },
    {
        id: 2,
        title: "交互式智能机器人",
        description: "交互式机器人部件包括电池、电机、编码器、IMU、控制板、卡片电脑、RGBD 相机、激光雷达和转向舵机。可以用于ROS 多机通讯，OpenCV机器视觉，路径规划等实验和开发。该项目提升了学生在机器人操作系统和人工智能算法方面的实践技能。"
    },
    {
        id: 3,
        title: "智慧抓取系统",
        description: "系统以树莓派4B为主控，OpenCV为图像处理库，采用ROS机器人操作系统，内置MoveIt运动学，可实现物体识别、抓取、颜色追踪、码垛等多种功能。该项目锻炼了学生在计算机视觉和机械控制领域的综合应用能力。"
    },
    {
        id: 4,
        title: "智慧门禁系统",
        description: "集成人脸识别、红外体温识别、高温警告、门禁控制、健康码核验、数据实时上传等功能的门禁系统。能简化进出操作，能有效减少人员接触、节约排队时间，对助力后疫情时代的健康防控有一定的工程应用价值。该项目体现了学生在物联网和疫情防控技术方面的创新能力。"
    },
    {
        id: 5,
        title: "智能果蔬采摘机器人",
        description: "智能果蔬采摘机器人项目培养学生在机器人控制、图像识别和自动控制方面的综合能力。通过该系统，学生可以学习机械臂控制、路径规划、视觉识别等关键技术。"
    },
    {
        id: 6,
        title: "智能高效分子光学诊断系统",
        description: "该系统结合了光学技术和分子诊断技术，培养学生在精密光学仪器设计和生物医学工程方面的实践能力。学生通过该项目掌握光路设计、信号处理和系统集成等技能。"
    },
    {
        id: 7,
        title: "智能生物分子分析系统",
        description: "智能生物分子分析系统项目涉及生物传感器、信号处理和数据分析技术。通过该项目，学生可以学习嵌入式系统在生物医学领域的应用，提升系统设计和工程实践能力。"
    },
    {
        id: 8,
        title: "智能工业巡检机器人",
        description: "智能工业巡检机器人项目涵盖了移动机器人导航、传感器融合和远程监控技术。学生通过该系统学习嵌入式系统在工业自动化中的应用，培养系统集成和故障诊断能力。"
    },
    {
        id: 9,
        title: "移动智能垃圾桶",
        description: "移动智能垃圾桶项目结合了物联网、传感器技术和自动控制技术。学生通过该项目学习智能设备的设计与开发，掌握环境感知、自主导航和人机交互等关键技术。"
    },
    {
        id: 10,
        title: "双手臂互联协同系统",
        description: "双手臂互联协同系统项目专注于多机器人协同控制技术。学生通过该系统学习多轴运动控制、协同算法和实时通信技术，提升在复杂控制系统设计方面的能力。"
    }
];

// 学生培养页面的项目数据
const studentsData = [
    {
        id: 1,
        title: "创新创业",
        description: "学生参与各类创新创业项目，培养实践能力和创新思维，通过实际项目锻炼解决复杂工程问题的能力。项目涵盖智能硬件开发、嵌入式系统设计、物联网应用等多个技术领域，全面提升学生的工程实践能力。学生在创新创业方面取得了显著成果。"
    },
    {
        id: 2,
        title: "学科竞赛",
        description: "学生积极参与各类学科竞赛，在光电设计大赛、全国大学生电子设计竞赛、挑战杯等高水平竞赛中屡获佳绩。通过竞赛实践，学生将理论知识与实际应用相结合，提升了创新能力和解决复杂工程问题的水平。"
    },
    {
        id: 3,
        title: "学术讲座",
        description: "学生积极参与各类学术讲座和学术交流活动，拓宽专业视野，了解前沿技术动态。通过与行业专家和学者的交流，学生能够把握技术发展趋势，提升学术素养和创新能力。"
    },
    {
        id: 4,
        title: "自主课堂",
        description: "学生参与自主课堂活动，通过自主学习和团队合作，提升自主学习能力和团队协作精神。在自主课堂中，学生能够充分发挥主观能动性，培养独立思考和解决问题的能力。"
    }
];

// 企业践习页面的项目数据
const enterpriseData = [
    {
        id: 1,
        title: "上海光联照明有限公司参观",
        description: "学生参观上海光联照明有限公司，了解现代照明技术的发展和应用。通过实地参观，学生了解了LED照明产品的设计、生产和测试流程，对光电技术的实际应用有了更深入的认识。"
    },
    {
        id: 2,
        title: "德国莱茵集团参观",
        description: "学生参观德国莱茵集团，了解国际领先的检测认证技术和质量管理体系。通过与企业技术人员的交流，学生对产品质量控制和国际标准有了更深刻的理解。"
    },
    {
        id: 3,
        title: "上海电动工具研究所（集团）有限公司参观",
        description: "学生参观上海电动工具研究所（集团）有限公司，了解电动工具的研发、设计和制造流程。通过实地参观，学生了解了电动工具产品的设计原理、生产工艺和质量检测标准，对机电一体化技术的实际应用有了更深入的认识。"
    },
    {
        id: 4,
        title: "上海三思电子工程有限公司参观",
        description: "学生参观上海三思电子工程有限公司，了解LED显示系统和智能交通产品的研发与生产流程。通过实地参观，学生了解了LED显示屏的设计原理、生产工艺和质量控制标准，对光电技术在智慧城市领域的应用有了更深入的认识。"
    },
    {
        id: 5,
        title: "浙江友邦集成吊顶股份有限公司参观",
        description: "学生参观浙江友邦集成吊顶股份有限公司，了解集成吊顶产品的设计、研发和生产流程。通过实地参观，学生了解了现代建筑装饰材料的生产工艺、质量控制体系和产品创新理念，对建筑装饰行业的发展趋势有了更深入的认识。"
    },
    {
        id: 6,
        title: "认识实习",
        description: "学生前往江苏芯梦半导体设备有限公司和华世德电子科技有限公司进行认识实习，深入了解半导体设备制造和电子科技行业的生产流程和技术应用。通过实地参观和学习，学生对相关行业的技术发展和产业现状有了更全面的认识，为后续的专业学习和职业规划奠定了基础。"
    }
];

class Home extends Component {
    componentDidMount() {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0
        };
    }

    // 轮播图切换
    nextSlide = () => {
        this.setState(prevState => ({
            currentSlide: (prevState.currentSlide + 1) % carouselData.length
        }));
    }

    // 轮播图自动播放
    componentDidMount() {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.carouselInterval = setInterval(this.nextSlide, 5000);
    }

    componentWillUnmount() {
        if (this.carouselInterval) {
            clearInterval(this.carouselInterval);
        }
    }

    render() {
        const { currentSlide } = this.state;

        return (
            <div>
                <Top />
                
                {/* 首页六部分布局 */}
                <div className="home-container">
                    {/* 1. 轮播图部分 */}
                    <div className="home-section home-carousel-section">
                        <div className="carousel-container">
                            <Link to={carouselData[currentSlide].link} className="carousel-slide">
                                <img src={carouselData[currentSlide].image} alt={carouselData[currentSlide].title} />
                                <div className="carousel-caption">
                                    <h3>{carouselData[currentSlide].title}</h3>
                                </div>
                            </Link>
                            <div className="carousel-indicators">
                                {carouselData.map((_, index) => (
                                    <span 
                                        key={index} 
                                        className={`indicator ${index === currentSlide ? 'active' : ''}`}
                                        onClick={() => this.setState({ currentSlide: index })}
                                    ></span>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 2. 课程介绍部分 */}
                    <div className="home-section home-course-section">
                        <Link to="/course-intro" className="home-content-card">
                            <div className="home-content-header">
                                <h3 className="home-content-title">课程介绍</h3>
                                <span className="home-content-more">更多 &gt;</span>
                            </div>
                            <div className="home-content-body">
                                <img src={courseImg} alt="课程介绍" className="home-content-image" />
                                <p className="home-content-desc">深入了解嵌入式系统设计的核心原理和实际应用</p>
                            </div>
                        </Link>
                    </div>

                    {/* 3. 案例与教学素材部分 */}
                    <div className="home-section home-projects-section">
                        <div className="home-content-card">
                            <div className="home-content-header">
                                <h3 className="home-content-title">案例与教学素材</h3>
                                <Link to="/projects" className="home-content-more">更多 &gt;</Link>
                            </div>
                            <div className="home-content-body">
                                <div className="home-content-list">
                                    {projectsData.slice(0, 5).map(project => (
                                        <Link to={`/project/${project.id}`} key={project.id} className="home-content-item">
                                            {project.title}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 4. 学生培养部分 */}
                    <div className="home-section home-students-section">
                        <div className="home-content-card">
                            <div className="home-content-header">
                                <h3 className="home-content-title">学生培养</h3>
                                <Link to="/students" className="home-content-more">更多 &gt;</Link>
                            </div>
                            <div className="home-content-body">
                                <div className="home-content-list">
                                    {studentsData.map(student => (
                                        <Link to={`/student/${student.id}`} key={student.id} className="home-content-item">
                                            {student.title}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 5. 企业践习部分 */}
                    <div className="home-section home-enterprise-section">
                        <div className="home-content-card">
                            <div className="home-content-header">
                                <h3 className="home-content-title">企业践习</h3>
                                <Link to="/enterprise" className="home-content-more">更多 &gt;</Link>
                            </div>
                            <div className="home-content-body">
                                <div className="home-content-list">
                                    {enterpriseData.map(enterprise => (
                                        <Link to={`/enterprise-project/${enterprise.id}`} key={enterprise.id} className="home-content-item">
                                            {enterprise.title}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 6. 师资建设部分 */}
                    <div className="home-section home-faculty-section">
                        <Link to="/faculty" className="home-content-card">
                            <div className="home-content-header">
                                <h3 className="home-content-title">师资建设</h3>
                                <span className="home-content-more">更多 &gt;</span>
                            </div>
                            <div className="home-content-body">
                                <img src={facultyImg} alt="师资建设" className="home-content-image" />
                            </div>
                        </Link>
                    </div>
                </div>
                
                {/* 版权信息 */}
                <div className="bot">
                    <div className="bot-wz">
                        <div className="bot-wz-1">Copyright © 2026</div>
                        <div className="bot-wz-1">上应大理学院光探测与感知课题组 版权所有</div>
                        <div className="bot-wz-1">豫ICP备2026001214号</div>
                        <div className="bot-wz-1">网站地图</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;